import Config from 'react-native-config';
import Qualtrics from 'react-native-qualtrics';

//import {toInteger} from 'lodash';
import {log} from '/util/logger.util';

import {getErrorTrackingUtilDefaultInstance} from '../error-tracking/error-tracking.util';

/*import {
  getAppVersion,
  getDeviceOsVersion,
  getDeviceType,
} from '/util/device-info.util';*/

// Set this to `true` to enable console logging of Qualtrics events.
// Do NOT commit that change into the repo.
const LOG_QUALTRICS_EVENTS = false;

export class QualtricsUtil {
  backend: any;

  consentStatus: any;

  initialized: any;

  verbose: any;

  constructor({verbose}: any) {
    this.verbose = verbose;
    this.backend = Qualtrics;
    this.consentStatus = false;

    this.initialized = false;
  }

  // QUALTRICS_BRAND_ID, QUALTRICS_PROJECT_ID will be same for QA & PROD
  initFeedback() {
    const BRAND_ID = Config.QUALTRICS_BRAND_ID;
    const PROJECT_ID = Config.QUALTRICS_PROJECT_ID;

    /* Qualtrics is initialised every time we call the qualtrics
        because we are having different survey feedback forms */

    return new Promise((resolve, reject) => {
      this.backend.initializeProjectWithExtRefId(
        BRAND_ID,
        PROJECT_ID,
        '',
        (initializationResults: any) => {
          let passed = true;
          let errorMessage = '';
          let errorKey = '';
          Object.keys(initializationResults).forEach(key => {
            if (!initializationResults[key].passed) {
              passed = false;
              errorMessage = initializationResults[key].message;
              errorKey = key;
            }
          });
          if (passed) {
            if (this.verbose) {
              log('[Qualtrics] Successfully initialized');
            }
            this.initialized = true;
            // @ts-expect-error TS(2794): Expected 1 arguments, but got 0. Did you forget to... Remove this comment to see the full error message
            resolve();
          } else {
            if (this.verbose) {
              log('[Qualtrics] Initialization failed');
            }
            reject(
              getErrorTrackingUtilDefaultInstance().trackError(
                `${errorKey}: ${errorMessage}`,
                'Qualtrics Error',
              ),
            );
          }
        },
      );
    });
  }

  setConsent(status: any) {
    this.consentStatus = status;
    if (this.verbose) {
      log(`[Qualtrics] consentStatus has been set to ${status}`);
    }
  }

  // TODO: Add Qualtrics correct integration with consent policy
  /*setProperties({coachId, coachName}) {
    if (this.consentStatus) {
      this.backend.setNumber('Coach Id', toInteger(coachId));
      this.backend.setString('Coach Name', coachName);
      this.backend.setString('App Version', getAppVersion());
      this.backend.setString('Device Type', getDeviceType());
      this.backend.setString('Device OS Version', getDeviceOsVersion());

      if (this.verbose) {
        log('[Qualtrics] Setting properties', {coachId, coachName});
      }
    }
  }*/

  showFeedbackView(interceptID: any) {
    const timeout = 200;

    setTimeout(() => {
      this.backend.evaluateIntercept(interceptID, (targetingResult: any) => {
        if (targetingResult.passed) {
          this.backend.displayIntercept(interceptID);
        } else {
          if (this.verbose) {
            log("[Qualtrics] The Feedback view isn't presented");
          }
        }
      });
    }, timeout);
  }
}

let QualtricsDefaultInstance: any = null;

export const getQualtricsDefaultInstance = () => {
  if (QualtricsDefaultInstance === null) {
    QualtricsDefaultInstance = new QualtricsUtil({
      verbose: LOG_QUALTRICS_EVENTS,
    });
  }

  return QualtricsDefaultInstance;
};
